/**
 * Small inline affordance shown next to a custom-field label when the field is read-only for the
 * employee (#10a `editableByEmployee = false`). The field stays visible but its input is disabled
 * and never submitted; this badge makes the intent explicit rather than looking like an
 * accidentally-greyed field.
 */
export function ReadOnlyBadge({ readOnly }: { readOnly?: boolean }) {
  if (!readOnly) {
    return null;
  }

  return (
    <span className="rounded-md bg-neutral-50 px-1.5 py-0.5 text-xs font-medium text-txt-tertiary">
      Alleen-lezen
    </span>
  );
}
